import list from './list';
import edit from './edit';
import create from './create';
import { isSuperAdmin, isAdmin } from 'utils';

export default (permissions) => {
  // Super Admins and Admins only
  const isVisible = isSuperAdmin(permissions) || isAdmin(permissions);

  return {
    name: 'help',
    list: isVisible ? list : null,
    edit: isVisible ? edit : null,
    create: isVisible ? create : null,
    icon: 'question-circle',
    options: {
      menuIndex: 6,
      isHidden: !isVisible,
    },
  };
};
